import { IconButton, Tooltip, type SxProps, type Theme } from "@mui/material";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { READ_ONLY_TOOLTIP_MESSAGE } from "@/utils/permissions";

/** 行の「非表示にする」ボタン。読み取り専用ユーザーには押せない旨をツールチップで伝える。 */
export const DismissButton: React.FC<{
  isReadOnly: boolean;
  onClick: () => void;
  sx?: SxProps<Theme>;
}> = ({ isReadOnly, onClick, sx }) => (
  <Tooltip title={isReadOnly ? READ_ONLY_TOOLTIP_MESSAGE : "非表示にする"}>
    <span>
      <IconButton
        size="small"
        aria-label="非表示にする"
        disabled={isReadOnly}
        onClick={onClick}
        sx={sx}
      >
        <VisibilityOffOutlinedIcon fontSize="small" />
      </IconButton>
    </span>
  </Tooltip>
);
